import { CapoPlugin } from "/Users/alexandarvalov/Documents/GitHub/Milab/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];